'use client';

import styled from 'styled-components';

import { Skeleton } from '@zoomit/primitives';
import { cssVar, elevation, theme } from '@zoomit/zoomit-ds';

import { isMobile } from '../../../../constants/media-query';

const CardSkeleton = (itemsCount: number) =>
  Array.from({ length: itemsCount }).map((_, index) => (
    <Root key={index}>
      <Skeleton className="aspect-primary" />
      <div className="detail">
        <Skeleton variant="text" />
        <Skeleton width="40%" variant="text" className="mt-4" />
        <Skeleton width="25%" variant="text" className="mt-10" />
      </div>
    </Root>
  ));

export default CardSkeleton;

const Root = styled.div`
  border-radius: var(${theme.radius.sm});
  overflow: hidden;
  background-color: ${cssVar(theme.background2)};
  ${elevation};
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.8rem;
  ${isMobile &&
  `
  min-width: 27.3rem;
  `}
  .detail {
    padding: 3.2rem 2.4rem 2rem;
  }
`;
